/* eslint-disable import/first */
import loadable from '@loadable/component';

export const ShareTrigger = loadable(() => (
  import('../sharing')
), { resolveComponent: mod => mod.ShareTrigger });
